import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { ArrowUpRightIcon } from './icons';
import './styles.scss';

const roles = [
  {
    tone: 'orange',
    label: 'Project Managers',
    headline: 'Stop chasing email. Start closing loops.',
    body:
      'RFIs route to the right reviewer instantly, and every response lands with timestamp, role, and stamp — ready for the closeout binder. Submittals track their own deadlines.',
    quotes: [
      '“Which open RFIs are blocking the L3 pour?”',
      '“Show every submittal past its review date.”',
    ],
    linkLabel: 'Explore RFIs',
    to: '/features/rfi',
  },
  {
    tone: 'blue',
    label: 'Superintendents',
    headline: 'The field runs the day. The record keeps up.',
    body:
      'Two minutes a day captures weather, crews, hours, photos, and progress — even offline at the slab edge. Punch items get photo proof, logged on the spot.',
    quotes: [
      '“Who was on site yesterday, and what did we pour?”',
      '“Which punch items are still open in Unit 412?”',
    ],
    linkLabel: 'Explore Daily Logs',
    to: '/features/daily_log',
  },
  {
    tone: 'green',
    label: 'Executives & Owners',
    headline: 'Proof, not promises, on every project.',
    body:
      "A stamped audit trail on demand, owner-ready exports in one click — and a software bill that's a flat fee, not a percentage of your construction volume.",
    quotes: [
      '“How is closeout tracking across projects?”',
      '“What are we actually paying per project?”',
    ],
    linkLabel: 'See pricing',
    to: '/pricing',
  },
];

export default function RoleSection() {
  return (
    <section className="plh-roles">
      <Reveal className="plh-lead">
        <p className="plh-eyebrow">ProjectLoop by role</p>
        <h2>
          Different roles. <span className="plh-accent">Same record.</span> Different wins.
        </h2>
        <p className="plh-lead__sub">
          One capture in the field answers a different question at every desk. Nobody re-types
          anything.
        </p>
      </Reveal>
      <div className="plh-roles__grid">
        {roles.map((role, idx) => (
          <Reveal className={`plh-role plh-role--${role.tone}`} key={role.label} delay={idx * 80}>
            <span className="plh-role__glyph" aria-hidden="true">
              <ArrowUpRightIcon />
            </span>
            <p className="plh-role__label plh-mono">{role.label}</p>
            <h3>{role.headline}</h3>
            <p className="plh-role__body">{role.body}</p>
            <div className="plh-role__inset">
              <p className="plh-role__inset-label plh-mono">From the record</p>
              {role.quotes.map((quote) => (
                <p className="plh-role__quote" key={quote}>
                  {quote}
                </p>
              ))}
            </div>
            <Link className="plh-role__link" to={role.to}>
              {role.linkLabel} <span aria-hidden="true">→</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
